import type File from '../../../interfaces/File';
import { IMAGE_PREVIEW_FULL_AUTO_MAX_BYTES } from '../../../utils/filePreview';
import { isImageFileExtension, removeShortcutExtension } from '../../../utils/utils';

/** True when `fileExtension` is an image type (shortcut suffix stripped). */
export function isPreviewableImageExtension(fileExtension: string | undefined): boolean {
  if (fileExtension == null || fileExtension === '') return false;
  return isImageFileExtension(removeShortcutExtension(fileExtension));
}

/**
 * Builds the preview carousel sequence from the file list and registered thumbnail URLs.
 * Only image files with a registered thumbnail are included; order follows `files`.
 */
export function buildOrderedPreviewFileIds(
  files: File[],
  thumbnailUrlByFileId: Record<number, string>,
): number[] {
  return files
    .filter((file) => !file.isFolder && isPreviewableImageExtension(file.fileExtension))
    .map((file) => file.id)
    .filter((fileId) => Boolean(thumbnailUrlByFileId[fileId]));
}

/**
 * Whether the current preview slide should show the "load HD" control on the image.
 */
export function shouldShowLoadFullQualityButton(
  file: File | undefined,
  hasFullRes: boolean,
  isLoading: boolean,
): boolean {
  if (!file || hasFullRes || isLoading) return false;
  if (!isPreviewableImageExtension(file.fileExtension)) return false;
  return file.fileSize >= IMAGE_PREVIEW_FULL_AUTO_MAX_BYTES;
}
